import type * as EchartsCore from 'echarts/core'

export async function loadEcharts(): Promise<typeof EchartsCore> {
  const { echarts } = await import(
    /* webpackChunkName: "echarts" */ '@app/shared/echarts'
  )
  return echarts
}
